import OrdenPreparacionAPI from '@/api/venta/ordenPreparacion';

export default {
  namespaced: true,
  actions: {
    fetch_orden(_, params) {
      return OrdenPreparacionAPI.index(params);
    },
    get_orden(_, id) {
      return OrdenPreparacionAPI.show(id);
    },
    create_orden(_, data) {
      return OrdenPreparacionAPI.create(data);
    },
    update_orden(_, { id, data }) {
      return OrdenPreparacionAPI.update(id, data);
    },
    cambiar_estado_orden(_, { id, estado }) {
      return OrdenPreparacionAPI.cambiarEstado(id, estado);
    },
    descargar_etiqueta_orden(_, id) {
      return OrdenPreparacionAPI.etiqueta(id);
    },
    descargar_etiquetas_bultos_orden(_, id) {
      return OrdenPreparacionAPI.etiquetasBultos(id);
    },
    get_ordenes_produccion(_, id) {
      return OrdenPreparacionAPI.ordenesProduccion(id);
    },
  },
};
